/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoringTemplateTrackCurveMnemonic
 */
export interface MonitoringTemplateTrackCurveMnemonic {
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveMnemonic
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveMnemonic
     */
    mnemonicLong?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveMnemonic
     */
    mnemonicShort?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveMnemonic
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveMnemonic
     */
    description?: string;
}

/**
 * Check if a given object implements the MonitoringTemplateTrackCurveMnemonic interface.
 */
export function instanceOfMonitoringTemplateTrackCurveMnemonic(value: object): value is MonitoringTemplateTrackCurveMnemonic {
    return true;
}

export function MonitoringTemplateTrackCurveMnemonicFromJSON(json: any): MonitoringTemplateTrackCurveMnemonic {
    return MonitoringTemplateTrackCurveMnemonicFromJSONTyped(json, false);
}

export function MonitoringTemplateTrackCurveMnemonicFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringTemplateTrackCurveMnemonic {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'mnemonicLong': json['mnemonicLong'] == null ? undefined : json['mnemonicLong'],
        'mnemonicShort': json['mnemonicShort'] == null ? undefined : json['mnemonicShort'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function MonitoringTemplateTrackCurveMnemonicToJSON(value?: MonitoringTemplateTrackCurveMnemonic | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'mnemonicLong': value['mnemonicLong'],
        'mnemonicShort': value['mnemonicShort'],
        'name': value['name'],
        'description': value['description'],
    };
}

